export class MenuItem {
    children = [];
    permissions = [];
    menuId = null;
    order = 0;

    constructor(id, version, force_url, route, text, parentMenuItemId, icon) {
        this.id = id
        this.version = version;
        this.force_url = force_url;
        this.route = route;
        this.parentMenuItemId = parentMenuItemId;
        this.text = text;
        this.icon = icon;
    }

    addChildren(child) {
        this.children.push(child)
    }

    addPermission(permission) {
        this.permissions.push(permission)
    }
}
